module.exports = __webpack_public_path__ + "img/6.310c0812.jpg";